/**
 * Auto-loads deferred media content on mobile devices
 * This ensures videos are playable directly from the gallery without requiring a modal
 * and preserves the poster image for better user experience
 */
if (!customElements.get('auto-load-deferred-media')) {
  customElements.define('auto-load-deferred-media', class AutoLoadDeferredMedia extends HTMLElement {
    constructor() {
      super();
      // Wait for DOM to be fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init.bind(this));
      } else {
        this.init();
      }
    }

    init() {
      // Only run on mobile devices
      if (window.innerWidth <= 749) {
        // Find all deferred-media elements in product media items
        const deferredMediaElements = document.querySelectorAll('.product__media-item .deferred-media');

        // For each deferred-media element, ensure it has a template before loading content
        deferredMediaElements.forEach(media => {
          // Extract the poster image URL before loading content
          const posterImg = media.querySelector('.deferred-media__poster img');
          let posterUrl = null;

          if (posterImg && posterImg.src) {
            posterUrl = posterImg.src;
          }

          // Check if the media has a template
          const template = media.querySelector('template');

          if (template && typeof media.loadContent === 'function') {
            // Call the loadContent method with focus set to false
            media.loadContent(false);

            // After loading content, set the poster attribute on the video element
            if (posterUrl) {
              const videoElement = media.querySelector('video');
              if (videoElement) {
                videoElement.setAttribute('poster', posterUrl);
              }
            }
          } else {
            // If no template is found, look for a corresponding modal-opener with the same media-id
            const mediaId = media.getAttribute('data-media-id');
            if (mediaId) {
              const modalOpener = document.querySelector(`.product__modal-opener[data-media-id="${mediaId}"]`);
              if (modalOpener) {
                const modalTemplate = modalOpener.parentElement.querySelector('template');
                if (modalTemplate) {
                  // Clone the template from the modal-opener and append it to the deferred-media
                  media.appendChild(modalTemplate.cloneNode(true));
                  // Now try loading the content
                  if (typeof media.loadContent === 'function') {
                    media.loadContent(false);

                    // After loading content, set the poster attribute on the video element
                    if (posterUrl) {
                      const videoElement = media.querySelector('video');
                      if (videoElement) {
                        videoElement.setAttribute('poster', posterUrl);
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }
    }
  });
}